module.exports = __webpack_public_path__ + "img/cbs-queue.f030fb02.svg";